export default __webpack_public_path__ + "static/science-ad2eaa899aa475f9d4ce9d40a913e2fbd950f186bd3d87769643de6ba1d70b2c.svg";